<template>
  <div :class="$b({ size, colour })" />
</template>

<script>
export default {
  name: 'LoadingSpinner',

  props: {
    size: {
      type: String,
      default: 'regular',
      validator: (value) => {
        return ['regular', 'small'].includes(value)
      },
    },
    colour: {
      type: String,
      default: 'blue',
      validator: (value) => {
        return ['blue', 'white', 'off-black'].includes(value)
      },
    },
  },
}
</script>

<style lang="postcss">
.LoadingSpinner {
  @apply animate-spin;
  height: 34px;
  width: 34px;

  &--size-small {
    @apply w-4 h-4;
  }

  &--colour-off-black {
    @apply border-2 border-off-black border-r-transparent
      rounded-full;
  }

  &--colour-blue {
    @apply border-2 border-blue border-r-transparent
      rounded-full;
  }

  &--colour-white {
    @apply relative;

    &:before {
      @apply absolute content-[''] inset-0 bg-contain;
      background-image: url('~/assets/svg/loading-spinner.svg');
    }
  }
}
</style>
